<template>
	<div class="load-more">
		<slot></slot>

		<default-section
			v-if="items && items.length > 0"
			class="card__container default-section--large-width"
			aria-live="polite"
		>
			<ul class="card__list">
				<li v-for="(item, index) of items" :key="index" class="card__list-item">
					<default-card
						card-color="transparent"
						:content="item.content"
						:style="`--card-color:${item.color};`"
						:title="item.title"
						:link="item.linkUrl"
					>
						<template #poster v-if="item.imageUrl">
							<default-picture
								:decorative="true"
								:source="{
									fallback: {
										loading: 'lazy',
										src: item.imageUrl,
									},
								}"
							></default-picture>
						</template>
						<template #header v-if="item.subtitle">
							<h3 class="card__tag">{{ item.subtitle }}</h3>
						</template>
					</default-card>
				</li>
			</ul>
		</default-section>

		<default-section
			v-if="error"
			class="load-more__error default-section--large-width"
			aria-live="polite"
		>
			<h2>{{ error.message }}</h2>
		</default-section>

		<div v-if="!hideButton && hasRecords" class="load-more__btn-container">
			<button
				class="cta-btn"
				:class="{ 'cta-btn--loading': isLoading }"
				:disabled="isLoading"
				@click="fetchData"
			>
				{{ buttonLabel }}
				<i class="spinner"></i>
			</button>
		</div>
	</div>
</template>

<script>
import Api from '../../services/Api';
import DefaultCard from '../DefaultCard';
import DefaultPicture from '../DefaultPicture';
import DefaultSection from '../DefaultSection';

export default {
	name: 'LoadMoreCards',
	components: {
		DefaultCard,
		DefaultPicture,
		DefaultSection,
	},
	props: {
		buttonLabel: { type: String, required: true },
		hideButton: { type: Boolean, required: false, default: false },
		pageSize: { type: Number, required: false, default: 4 },
		url: { type: String, required: true },
	},
	data() {
		return {
			error: null,
			hasRecords: true,
			items: [],
			isLoading: false,
			pageIndex: 1,
		};
	},
	methods: {
		async fetchData() {
			this.isLoading = true;

			try {
				let url = null;

				try {
					url = new URL(this.url);
				} catch (e) {
					url = new URL(this.url, document.location);
				}

				url.searchParams.append('pageIndex', this.pageIndex);
				url.searchParams.append('pageSize', this.pageSize);

				const query = await Api.get(url.href);
				const { response } = query;
				const { data, status } = response;
				const { errorMessage, hasRecords, items } = data;

				if (status !== 200) {
					throw errorMessage;
				}

				if (Array.isArray(items)) {
					this.items = this.items.concat(items);
					this.hasRecords = hasRecords;
					this.pageIndex++;
				} else {
					throw new Error(errorMessage);
				}
			} catch (e) {
				this.error = e;
			} finally {
				this.isLoading = false;
			}
		},
	},
};
</script>
